export interface IInventory {
  idInventory: string;
  idBranch: string;
  description: string;
  uidCreatedBy: string;
  uidUpdatedBy: string;
  createdAt: string;
  updatedAt: string;
}

export class Inventory {
  idInventory: string;
  idBranch: string;
  description: string;
  uidCreatedBy: string;
  uidUpdatedBy: string;
  createdAt: Date;
  updatedAt: Date;

  constructor(data: IInventory) {
    this.idInventory = data.idInventory;
    this.idBranch = data.idBranch;
    this.description = data.description;
    this.uidCreatedBy = data.uidCreatedBy;
    this.uidUpdatedBy = data.uidUpdatedBy;
    this.createdAt = new Date(data.createdAt);
    this.updatedAt = new Date(data.updatedAt);
  }
}
